// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', {fround: require('./_math-fround')});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.math.fround.js
// module id = 252
// module chunks = 0